import { useFormik } from "formik";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { changePassword, getOtp } from "../../../../services";
import { useSessionStore } from "Common/Stores";
import { NotificationType, showNotifications } from "helpers/toas_notification";
import { ChangePassword } from "interfaces";

export const useResetPassword = () => {
  const { t } = useTranslation();

  const navigate = useNavigate();

  const { session } = useSessionStore();

  const [steepValue, setSteepValue] = useState(1);

  const initialValues = {
    password: "",
    confirmPassword: "",
    currentPassword: "",
  };

  const validationSchema = Yup.object({
    currentPassword: Yup.string().required(t("validationForms.required")),
    password: Yup.string().required(t("validationForms.required")),
    confirmPassword: Yup.string()
      .required(t("validationForms.required"))
      .oneOf([Yup.ref("password")], t("validationForms.passwordMatch")),
  });

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      //Request code otp here

      if (!session?.user?.email) return;

      const response = await getOtp(session?.user?.email);

      console.log(response, values);

      if (response?.code === "200") {
        showNotifications(
          NotificationType.SUCCESS,
          t("registerScreen.succedGenerateOTP")
        );
        nextSteep();
      } else {
        showNotifications(
          NotificationType.ERROR,
          t("registerScreen.ErrorGenerateOTP")
        );
      }
    },
  });

  const resendOtp = async () => {
    if (!session?.user?.email) return;

    const response = await getOtp(session?.user?.email);

    console.log(response);

    if (response?.code === "200") {
      showNotifications(
        NotificationType.SUCCESS,
        t("registerScreen.succedGenerateOTP")
      );
    } else {
      showNotifications(
        NotificationType.ERROR,
        t("registerScreen.ErrorGenerateOTP")
      );
    }
  };

  const initialValuesOtp = {
    code1: "",
    code2: "",
    code3: "",
    code4: "",
  };

  const validationSchemaOtp = Yup.object({
    code1: Yup.string().required(t("validationForms.required")),
    code2: Yup.string().required(t("validationForms.required")),
    code3: Yup.string().required(t("validationForms.required")),
    code4: Yup.string().required(t("validationForms.required")),
  });

  const formikOtp = useFormik({
    initialValues: initialValuesOtp,
    validationSchema: validationSchemaOtp,
    onSubmit: async (values) => {
      if (!session?.user?.email) return;

      const payload: ChangePassword = {
        otp: `${values.code1}${values.code2}${values.code3}${values.code4}`,
        user: session.user.email || "",
        currentPassword: formik.values.currentPassword,
        newPassword: formik.values.password,
      };

      console.log(payload);

      const response = await changePassword(payload);

      console.log(response);

      if (response?.code === "200") {
        showNotifications(
          NotificationType.SUCCESS,
          t("OtpValidation.succedVerifyOTP")
        );
        navigate("/dashboard");
      } else {
        showNotifications(
          NotificationType.ERROR,
          t("OtpValidation.ErrorVerifyOTP")
        );
      }
    },
  });

  const nextSteep = () => {
    setSteepValue(steepValue + 1);
  };

  return {
    formik,
    formikOtp,
    steepValue,
    nextSteep,
    resendOtp,
  };
};
